export default "__VITE_ASSET__BB8qwMMv__"